import api from '@pray/shared/utils/api';

export type DeleteMarketingCampaignParams = {
  artistId: string;
  campaignId: string;
};

export const deleteMarketingCampaign = async ({ artistId, campaignId }: DeleteMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
};
